<template>
    <PimProductTableList class="pim-product-table-list--samples" :headers="headers" v-if="samples && samples.length">
        <template v-if="renderDecorStructureColumn">
            <PimProductTableListRow v-for="(sample, index) in samples" :key="sample.pim_id">
                <PimProductTableListColumn :class="{'d-none d-lg-block': !(sample.image_d_src || sample.image_s_src)}">
                    <template v-if="sample.image_d_src">
                        <GlobalInlineTile :title="'<b>' + sample.title_d + '</b> ' + sample.subtitle_d" :title-link="renderLinks ? sample.link_d : null" :image="sample.image_d_src"
                                          :imageLink="renderLinks ? sample.link_d : null" :text="sample.note_d" :subtitle="sampleStructures(sample.structures)"/>
                    </template>
                    <template v-else-if="sample.image_s_src">
                        <GlobalInlineTile :title="'<b>' + sample.title_s + '</b> ' + sample.subtitle_s" :title-link="renderLinks ? sample.link_s : null" :image="sample.image_s_src"
                                          :imageLink="renderLinks ? sample.link_s : null" :text="sample.note_s"/>
                    </template>
                </PimProductTableListColumn>
                <PimProductTableListColumn>
                    <GlobalInlineTile v-if="sample.title_t" :title="'<b>' + sample.title_t + '</b>'" :title-link="renderLinks ? sample.link_t : null" :image="sample.image_t_src"
                                      :imageLink="renderLinks ? sample.link_t : null" :subtitle="sample.note_t"/>
                    <GlobalInlineTile v-if="sample.title_r" :title="'<b>' + sample.title_r + '</b>'" :title-link="renderLinks ? sample.link_r : null" :image="sample.image_r_src"
                                      :imageLink="renderLinks ? sample.link_r : null" :subtitle="sample.note_r"/>
                </PimProductTableListColumn>
                <PimProductTableListColumn>
                    <span class="d-lg-none">
                        <GlobalInlineTile :image-alternative="`${labelFormat}:`" :title="`${(sample.format ? sample.format : '--')}`"/>
                    </span>
                    <span class="d-none d-lg-block">
                        <template v-if="sample.format">{{sample.format}}</template><template v-else>--</template>
                    </span>
                </PimProductTableListColumn>
                <PimProductTableListColumn>
                    <div class="button-wrapper spaced--narrow v-center right">
                        <slot name="actions" :item="sample" :index="index">
                            Please override the "actions" slot in your template. The "item" and the "index" are passed as properties.
                        </slot>
                    </div>
                </PimProductTableListColumn>
            </PimProductTableListRow>
        </template>
        <template v-else>
            <PimProductTableListRow v-for="(sample, index) in samples" :key="sample.pim_id">
                <PimProductTableListColumn>
                    <GlobalInlineTile v-if="sample.title_t" :title="'<b>' + sample.title_t + '</b>'" :title-link="renderLinks ? sample.link_t : null" :image="sample.image_t_src"
                                      :imageLink="renderLinks ? sample.link_t : null" :subtitle="sample.note_t"/>
                    <GlobalInlineTile v-if="sample.title_r" :title="'<b>' + sample.title_r + '</b>'" :title-link="renderLinks ? sample.link_r : null" :image="sample.image_r_src"
                                      :imageLink="renderLinks ? sample.link_r : null" :subtitle="sample.note_r"/>
                </PimProductTableListColumn>
                <PimProductTableListColumn/>
                <PimProductTableListColumn>
                    <div class='d-none d-lg-block'>
                        <span class='d-lg-none'>{{ labelFormat }}: </span>
                        <span v-if="sample.format">{{ sample.format }}</span>
                        <span v-else>--</span>
                    </div>
                    <GlobalInlineTile class="d-lg-none" :title="`${labelFormat}: ${(sample.format ? '<span>' + sample.format + '</span>' : '--')}`"/>
                </PimProductTableListColumn>
                <PimProductTableListColumn>
                    <div class="button-wrapper spaced--narrow v-center right">
                        <slot name="actions" :item="sample" :index="index">
                            Please override the "actions" slot in your template. The "item" and the "index" are passed as properties.
                        </slot>
                    </div>
                </PimProductTableListColumn>
            </PimProductTableListRow>
        </template>
    </PimProductTableList>
</template>

<script>

import GlobalInlineTile from "@global/global-elements/global-inline-tile/global-inline-tile.vue";
import PimProductTableList from "@src/Resources/epim/Partials/PimProductTableList/pim-product-table-list.vue";
import PimProductTableListRow from "@src/Resources/epim/Partials/PimProductTableList/pim-product-table-list-row.vue";
import PimProductTableListColumn from "@src/Resources/epim/Partials/PimProductTableList/pim-product-table-list-column.vue";
import CartButton from "@src/Resources/epim/Partials/Shop/cart-button.vue";

export default {
    name: "pim-product-table-list-samples",
    components: {CartButton, PimProductTableListColumn, PimProductTableListRow, PimProductTableList, GlobalInlineTile},
    props: {
        samples: {
            type: Array,
            required: true
        },
        renderLinks: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            labelFormat: window.pimLocalization.sample.format || ""
        };
    },
    computed: {
        renderDecorStructureColumn() {
            return this.samples.some(sample => sample.image_d_src);
        },
        headers() {
            if (this.renderDecorStructureColumn) {
                return [
                    window.pimLocalization.sample.decorstructure,
                    window.pimLocalization.sample.product,
                    this.labelFormat,
                    ''
                ]
            } else {
                return [
                    window.pimLocalization.sample.product,
                    '',
                    this.labelFormat,
                    ''
                ]
            }

        },
    },
    methods: {
        sampleStructures(structures) {
            if (this.renderLinks) {
                return structures.map(structure => `<a href="${structure.link}"><b>${structure.title}</b> ${structure.titlesuffix}</a>`).join('<br>');
            }
            else {
                return structures.map(structure => `<b>${structure.title}</b> ${structure.titlesuffix}`).join('<br>');
            }
        }
    },
    created() {
    }
}
</script>
